import { useEffect } from "react"
import { useUserProfile } from "hooks/api/user/user.hook"
import { useCurrentUserStore } from "store/user.store"

// Fetches the profile and mirrors its id + role into `useCurrentUserStore`. Mounted by Userbar in
// the app shell AND by the pop-out window (#1466), which is routed before the shell — without it the
// pop-out has no user id, and core/documentBlobCache then re-downloads the drawing uncached.
export const useSyncCurrentUser = () => {
	const setCurrentUser = useCurrentUserStore((state) => state.setCurrentUser)
	const profileQuery = useUserProfile()
	const { data } = profileQuery

	useEffect(() => {
		setCurrentUser({
			id: data?.id,
			role: data?.role,
		})
	}, [data?.role, data?.id, setCurrentUser])

	return profileQuery
}
